// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.css.conf with an alias.
import Vue from 'vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App'
import router from './router';
import config from './config/config';
import common from './common/common';
import $ from 'jquery';
import Base64 from 'js-base64';
import  '@/common/touch-simulator.js'
import empty from '@/components/empty.vue'
Vue.use(Vant).component('empty',empty)
common(Vue)
//加载更多的组件

// 引入公共样式
require('@/style/base.css')

// 富文本编辑
import initRichText from './common/initHTMLEditor';
initRichText();


import echarts   from 'echarts'
import $api     from  './api/api';             // 接口
import $active from './api/active'; //活动接口
import store    from     './store/index'       // 全局状态管理
import 'lib-flexible/flexible';                // 移动端适配
import $Index from './globalComponent/index';  // 引入全局组件
import $common from './common/index';          // 引入全局配置
import $wxuserUtil from './common/wxuserUtil';  //用户工具类
$Index(Vue)
$common(Vue)
Vue.config.productionTip = false
Vue.prototype.$echarts   = echarts;            // 全局  Echarts
// Vue.prototype.$code=URL_                       // URL  字符串切割返回数据 code
Vue.prototype.$api=$api                       // 全局接口  this.$api  吊对象的接口配置   api/api.js
Vue.prototype.$api.$active=$active
/* eslint-disable no-new */
Vue.prototype.$wxuserUtil = $wxuserUtil;
Vue.prototype.$http  = config.serverURL;       // 当前域名地址
Vue.prototype.$  = $;       // 当前域名地址
Vue.prototype.$Base64 = Base64.Base64;
Vue.prototype.APPCFG  = config;

// 配置全局 jQuery AJAX 请求头
$.ajaxSetup({
  beforeSend: function(xhr) {
    // 添加 x-scope 请求头
    const scope = $wxuserUtil.getScope();
    if (scope) {
      xhr.setRequestHeader('x-scope', scope);
    }
  }
});

// import Vconsole from 'vconsole';
// if(process.env && process.env.NODE_ENV=='dev'){
//     let vConsole = new Vconsole()
//     Vue.use(vConsole);
// }

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  beforeMount : function () {
  }
});



// WEBPACK FOOTER //
// ./src/main.js